import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ConvertRegistrationService } from '@shared/services/convert-registration/convert-registration.service';
import { catchError, map, switchMap } from 'rxjs';

import { closeSpinner, Next, TrackProcessError } from '../../actions';
import {
  convertRegistration,
  convertRegistrationFail,
  convertRegistrationSuccess,
} from '../../actions/convert-registration/convert-registration.actions';

@Injectable()
export class ConvertRegistrationEffects {
  constructor(
    private actions$: Actions,
    private convertRegistrationService: ConvertRegistrationService,
  ) {}

  convertRegistration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(convertRegistration),
      switchMap(() => {
        return this.convertRegistrationService.convertEndpoint().pipe(
          switchMap((response) => {
            const returnActions = [];
            returnActions.push(convertRegistrationSuccess());
            if (!response.successful) {
              returnActions.push(TrackProcessError({ errorCode: 'coo-pvr_conversion' }));
            }
            returnActions.push(closeSpinner());
            return returnActions;
          }),
          catchError(() => {
            return [
              TrackProcessError({ errorCode: 'coo-pvr_system_error' }),
              closeSpinner(),
              convertRegistrationFail(),
            ];
          }),
        );
      }),
    ),
  );

  convertRegistrationDone$ = createEffect(() =>
    this.actions$.pipe(
      ofType(convertRegistrationSuccess, convertRegistrationFail),
      map(() => {
        return Next();
      }),
    ),
  );
}
